import { buildEndpoint } from './build-endpoint';
import { Builder, EndpointsShape } from './create-api.model';
import { createApiHooks } from './create-api-hooks';
import { ApiHookOptions, ApiHooks } from './create-api-hooks.model';

const createApi = <T extends EndpointsShape, O extends ApiHookOptions<T>>(
    applyBuilder: Builder<T>,
    hookOptions?: O,
): T & ApiHooks<T, O> => {
    const endpoints = applyBuilder(buildEndpoint);
    const hooks = createApiHooks(endpoints, hookOptions);

    return {
        ...endpoints,
        ...hooks,
    };
};

export { createApi };
